import { Component } from '@angular/core';
import { SettingsPageService } from '../services/SettingsPage.service';
import { SessionService } from '../../../shared/services/Session.service';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css']
})
export class SettingsPageComponent {

  selectedTabIndex: number = 0;

  constructor( private settingsService: SettingsPageService, private sessionService: SessionService) {

  }

  ngOnInit() {
    this.sessionService.setIsExternalMap(false);
    this.selectedTabIndex = this.settingsService.getSelectedTab();
  }

  onTabChange(tab: any): void {
    this.selectedTabIndex = tab.index;
    this.settingsService.setSelectedTab(tab.index);
  }

}
